import { render } from "./RoomTypeOfView.vue?vue&type=template&id=4d12d9ba"
import script from "./RoomTypeOfView.vue?vue&type=script&lang=js"
export * from "./RoomTypeOfView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__